"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoQuestionCollapseWrapperWithOptionalFields = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var InfoQuestionCollapseWrapperWithOptionalFields = /** @class */ (function (_super) {
    __extends(InfoQuestionCollapseWrapperWithOptionalFields, _super);
    function InfoQuestionCollapseWrapperWithOptionalFields(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(_this.props.className || "", "\n                ").concat(_this.state.isInfoSectionOpen ? (_this.props.classNameOpened || "info-box inner-content negative-margin width-auto") : ""), children: [(0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-between align-items-start info-button-start", children: [_this.props.label ? _this.renderLabel() : "", _this.props.info ? _this.renderInfoBlock() : ""] }), _this.state.isInfoSectionOpen && _this.renderInfoSection(), (0, jsx_runtime_1.jsx)("div", { className: "info-child-container", children: _this.props.children }), _this.props.additionalText ? _this.renderAdditionalText() : ""] }));
        };
        _this.renderInfoBlock = function () {
            return (0, jsx_runtime_1.jsx)("button", { tabIndex: 0, className: "info-button ml-2 cursor-pointer ".concat(_this.state.isInfoSectionOpen ? "selected" : ""), "aria-label": "Info button for more information about NCD", onClick: _this.toggleInfoSection, onKeyDown: _this.toggleInfoSection });
        };
        _this.toggleInfoSection = function () {
            _this.setState(function (state) { return ({
                isInfoSectionOpen: !state.isInfoSectionOpen
            }); });
        };
        _this.renderInfoSection = function () {
            return (_this.props.info);
        };
        _this.renderAdditionalText = function () {
            return (0, jsx_runtime_1.jsx)("p", { children: _this.props.additionalText });
        };
        _this.state = {
            isInfoSectionOpen: false
        };
        return _this;
    }
    InfoQuestionCollapseWrapperWithOptionalFields.prototype.renderLabel = function () {
        return (0, jsx_runtime_1.jsx)("label", { className: "no-wrap-label", children: this.props.label });
    };
    return InfoQuestionCollapseWrapperWithOptionalFields;
}(React.Component));
exports.InfoQuestionCollapseWrapperWithOptionalFields = InfoQuestionCollapseWrapperWithOptionalFields;
//# sourceMappingURL=InfoQuestionCollapseWrapperWithOptionalFields.js.map